
export const BASE_URL = 'http://localhost:4000/api/v1'